export default "__VITE_ASSET__BIcn2_gx__"